import React, { useRef } from 'react';
import styled from 'styled-components';
import { ZIndices } from '../common/zIndices';
import CONSTANTS from '../common/constants';

function StepBarComponent(props) {
  const barItems = props.items;
  const activeStage = props.activeStage;
  const scrollRef = useRef();

  const scroll = (dir) => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollAmount = 300;
    container.scrollBy({
      left: dir === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <StepBarStyle className={'progress-bar-container ' + (props.className || '')} itemPercentage={props.itemPercentage}>
        {barItems.map((barItem, barItemIndex) => (
          <div key={barItemIndex} className={'progress-cube' + (barItemIndex + 1 === activeStage ? ' active' : '')}>
            {barItem.icon}
            {barItems.length - 1 !== barItemIndex && (
              <div className={'cube-cross-line index-' + barItemIndex + (barItem.active ? ' active' : '')} />
            )}
            <div className="progress-bar-text">{barItem.text}</div>
          </div>
        ))}
      </StepBarStyle>
      {barItems[0]?.text !== "Disclaimer" && !barItems[0]?.text.includes("Create") && <div> 
      <CommentsHeader>What GOVIS Customers Say</CommentsHeader>
      <StepToCommentsSpacer />
      <CommentsContainer>
        <Arrow direction="left" onClick={() => scroll('left')}>&#8592;</Arrow>
        <CommentsBar ref={scrollRef}>
          {comments.map((c, i) => (
            <Comment key={i}>
              <div className="name">★ {c.name}</div>
              <div className="country">{c.country}</div>
              <div className="stars">⭐⭐⭐⭐⭐</div>
              <div className="text">{c.text}</div>
            </Comment>
          ))}
        </CommentsBar>
        <Arrow direction="right" onClick={() => scroll('right')}>&#8594;</Arrow>
      </CommentsContainer> </div>}
    </>
  );
}

const comments = [
  { name: "Alice Moreau", country: "France", text: "Absolutely satisfied with the service." },
  { name: "Victoria Evans", country: "Canada", text: "I got my visa in just a few hours!" },
  { name: "Natalie Foster", country: "USA", text: "Highly recommend this for travelers." },
  { name: "Anton Petrov", country: "Bulgaria", text: "One of the best platforms I’ve used." },
  { name: "Sophia Rossi", country: "Italy", text: "Absolutely satisfied with the service." },
  { name: "Elena Popescu", country: "Romania", text: "Fast, professional, and reliable." },
  { name: "Lukas Steiner", country: "Austria", text: "Fast, professional, and reliable." },
  { name: "Sara Johnson", country: "United States", text: "Super fast approval, very happy!" },
  { name: "Megan Harris", country: "USA", text: "Everything worked perfectly." },
  { name: "Michael O’Connor", country: "Ireland", text: "User-friendly website and great support." },
  { name: "Daniel Kim", country: "Switzerland", text: "Fast, professional, and reliable." },
  { name: "Chloe Dubois", country: "France", text: "Super fast approval, very happy!" },
  { name: "Isabelle Tremblay", country: "Canada", text: "Everything worked perfectly." },
  { name: "Hannah Holmes", country: "UK", text: "Clear instructions and easy to follow." },
  { name: "Maya Singh", country: "Ireland", text: "Clear instructions and easy to follow." },
  { name: "Tobias Berg", country: "Norway", text: "Very efficient and trustworthy." },
  { name: "Amy Turner", country: "New Zealand", text: "Highly recommend this for travelers." },
  { name: "Victor White", country: "Netherlands", text: "Fast, professional, and reliable." },
  { name: "Sophie Dubois", country: "France", text: "Fast, professional, and reliable." },
  { name: "Carla Costa", country: "Portugal", text: "Highly recommend this for travelers." },
  { name: "Olivia Wilson", country: "USA", text: "Super fast approval, very happy!" },
  { name: "Frederik Hansen", country: "Denmark", text: "Very efficient and trustworthy." },
  { name: "Tomáš Dvořák", country: "Czech Republic", text: "Very efficient and trustworthy." },
  { name: "Emily Clark", country: "New Zealand", text: "Absolutely satisfied with the service." },
  { name: "Emma Johansson", country: "Sweden", text: "One of the best platforms I’ve used." },
  { name: "David Smith", country: "UK", text: "Clear instructions and easy to follow." },
  { name: "Anna Müller", country: "Germany", text: "Fast, professional, and reliable." },
  { name: "Sebastian Keller", country: "Germany", text: "Everything worked perfectly." },
  { name: "Lucas Müller", country: "Germany", text: "Will definitely use again next time." },
  { name: "Markus Weber", country: "Switzerland", text: "Everything worked perfectly." },
  { name: "Benjamin Miller", country: "Austria", text: "Super fast approval, very happy!" },
  { name: "Luca Romano", country: "Italy", text: "Fantastic experience overall." },
  { name: "Henry Brown", country: "UK", text: "Absolutely satisfied with the service." },
  { name: "Laura Schmidt", country: "Germany", text: "Everything worked perfectly." },
  { name: "Jack Martin", country: "United Kingdom", text: "I got my visa in just a few hours!" },
  { name: "James Baker", country: "Australia", text: "One of the best platforms I’ve used." },
  { name: "Julia Novak", country: "Czech Republic", text: "Super fast approval, very happy!" },
  { name: "Nina Kovacs", country: "Hungary", text: "Very efficient and trustworthy." },
  { name: "Samantha Brown", country: "Canada", text: "Amazing service from start to finish." },
  { name: "Linda Nielsen", country: "Norway", text: "Quick turnaround time and smooth interface." }
];


const CommentsContainer = styled.div`
  position: relative;
  width: 100vw;
  padding: 0 20px;
  box-sizing: border-box;
`;

const StepToCommentsSpacer = styled.div`
  margin-top: 40px;
  margin-bottom: 10px;
  border-top: 1px solid #ccc;
  width: 100%;
`;

const Arrow = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ direction }) => (direction === 'left' ? 'left: 0;' : 'right: 0;')}
  background: #ffffff;
  border: 1px solid #ccc;
  border-radius: 50%;
  padding: 10px 14px;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;

  &:hover {
    background: #f9f9f9;
  }
`;
const CommentsBar = styled.div`
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  padding: 20px 0;
  background: #003366; /* Matches 'How do I get the visa' section */
  scroll-behavior: smooth;
  gap: 10px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const Comment = styled.div`
  flex: 0 0 auto;
  min-width: 260px;
  margin: 10px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.05); /* subtle transparency */
  color: #ffffff;
  border-radius: 8px;
  font-size: 0.95rem;
  font-family: 'Segoe UI', sans-serif;
  text-align: left;
  border: 1px solid rgba(255, 255, 255, 0.2);

  .name {
    font-weight: 600;
    margin-bottom: 2px;
    color: #ffffff;
  }

  .country {
    font-size: 0.85rem;
    color: #cce0ff;
    margin-bottom: 6px;
  }

  .stars {
    color: #ffd700; /* golden stars */
    font-size: 1rem;
    margin-bottom: 5px;
  }

  .text {
    line-height: 1.4;
  }
`;
const CommentsHeader = styled.h2`
  margin: 30px 20px 10px 20px;
  font-size: 1.5rem;
  font-weight: 600;
  color: #003366;
  font-family: 'Segoe UI', sans-serif;
  text-align: left;

  @media (max-width: ${CONSTANTS.MEDIA_BREAKPOINTS_MOBILE}px) {
    font-size: 1.25rem;
    margin: 20px 16px 8px 16px;
  }
`;

const StepBarStyle = styled.div`
  position: relative;
  margin: 0 auto;
  display: flex;
  align-items: stretch;
  max-width: 1100px;

  @media (max-width: ${CONSTANTS.MEDIA_BREAKPOINTS_MOBILE}px) {
    display: block;
    html.rtl & { margin-right: 65px; }
    html.ltr & { margin-left: 65px; }
  }

  .progress-cube {
    position: relative;
    flex-grow: 1;
    text-align: center;
    width: ${props => props.itemPercentage}%;
    
    @media (max-width: ${CONSTANTS.MEDIA_BREAKPOINTS_MOBILE}px) {
      width: auto;
      margin-bottom: 10px;
      html.rtl & { text-align: right; }
      html.ltr & { text-align: left; }
    }

    > svg {
      position: relative;
      background-color: #32cd32;
      border-radius: 50%;
      color: white;
    }
  }

  .progress-bar-text {
    color: white;
    @media (max-width: ${CONSTANTS.MEDIA_BREAKPOINTS_MOBILE}px) {
      display: inline-block;
      position: relative;
      top: -6px;
      html.rtl & { padding-right: 5px; }
      html.ltr & { padding-left: 5px; }
    }
  }

  .cube-cross-line {
    position: absolute;
    height: 5px;
    background-color: #aaa;
    width: calc(100% - 16px);
    top: 10px;
    z-index: ${ZIndices.STEPS_BAR_CROSS_LINE};

    html.rtl & { right: calc(50% + 8px); }
    html.ltr & { left: calc(50% + 8px); }

    &.active {
      background-color: #1460aa;
    }

    @media (max-width: ${CONSTANTS.MEDIA_BREAKPOINTS_MOBILE}px) {
      right: 11px !important;
      top: 24px;
      width: 2px;
      height: 15px;
      html.rtl & { right: 11px !important; }
      html.ltr & { right: unset; left: 12px !important; }
    }
  }
`;

export default StepBarComponent;
